import { useAPI } from "@/services/api";
import { light } from "@/services/light";
import { Button } from "@Light/components/page/Button";
import { useEffect } from "react";
import { useDispatch } from "react-redux";

export type LogoutButtonProps = {};

export const LogoutButton: React.FC<LogoutButtonProps> = ({}) => {
  const { useLogoutMutation } = useAPI();
  const [logout, logoutState] = useLogoutMutation();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!logoutState.isSuccess) {
      return;
    }
    dispatch(light.util.invalidateTags(["Account"]));
  }, [logoutState.isSuccess, dispatch]);

  return <Button onClick={() => logout()}>Log out</Button>;
};
